 
import CarotekColors from "@carotek/utils/Colors";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

export interface CategoryHTMLContentStyles {
    container?: InjectableCss;
    title?: TypographyPresentationProps;
}

export const categoryStyles: CategoryHTMLContentStyles = {
    container: {
        css: css`
            margin-bottom: 10px;

            .cat-page-title h2 {
                font-size: 28px;
                font-family: "NeuronBold";
            }

            h3 {
                font-family: "Neuron";
                font-size: 22px !important;
                margin-top: 15px;
            }

            p,
            li {
                font-size: 14px !important;
            }

            .seal-pot-form-button a {
                margin: 20px 0 20px;
            }

            .cat-sub-section-one p,
            .cat-sub-section-two p {
                margin-bottom: 0;
                margin-top: 0;
            }

            .cat-section-wrapper {
                display: inline-block;
                padding-bottom: 10px;
            }

            .cat-sub-section-one {
                width: 60%;
                float: left;
                padding-right: 30px;
            }

            .cat-sub-section-two {
                float: right;
                width: 40%;
                display: inline-block;
            }

            .btn-promo {
                display: inline-block;
                background: ${getColor("primary")};

                color: ${CarotekColors.white};
                text-decoration: none;
                padding: 8px 10px;
                :hover {
                    background-color: #ab161a;
                    span {
                        text-decoration: none;
                    }
                }
                span {
                    color: ${CarotekColors.white} !important;
                    text-transform: uppercase;
                    font-weight: bold;
                    font-size: 14px;
                    font-family: "OpenSansBold";
                }
            }
        `,
    },
    title: {
        size: 16,
        css: css`
            [class^="TypographyStyle"] {
                font-size: 16px;

                margin-bottom: 5px;
            }
        `,
    },
};

const styles = categoryStyles;

const CategoryHTMLContent = ({ category, currentPage }: Props) => {
    if (!category || !category.htmlContent) {
        return null;
    }

    function extractBodyContent(html: string) {
        const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        return match ? match[1] : html;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.title}>{parse(extractBodyContent(category.htmlContent), parserOptions)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryHTMLContent)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
